import * as React from 'react';

import * as ct from '../../global/controls';
import {CustomerCategoryQuantityOverride} from "./reservationDetails";

interface ReservationCustomerCategoryQuantityOverrideItemProps {
    overrideMaxOverallQuantity: ct.FormValue<number>;
    reservationCustomerCategoryQuantityOverrideItem: CustomerCategoryQuantityOverride;
    maxOverallQuantityChanged: (customerCategoryId: string, val: number) => void;
}

const ReservationCustomerCategoryQuantityOverrideItem = (props: ReservationCustomerCategoryQuantityOverrideItemProps) => {
    const { reservationCustomerCategoryQuantityOverrideItem: {customerCategoryId, categoryName }, overrideMaxOverallQuantity, maxOverallQuantityChanged } = props;

    const inlineControlStyle = ({minHeight: '10px', marginRight: '10px'});
    const cellStyle = ({verticalAlign: 'top'});
    const textCellStyle = ({...cellStyle, paddingTop: '12px'});

    const onMaxOverallQuantityChange = (val: number | null) => {
        const { reservationCustomerCategoryQuantityOverrideItem: { activityFormatMaxOverallQuantity } } = props
        maxOverallQuantityChanged(customerCategoryId, val || activityFormatMaxOverallQuantity);
    }
    
    return <tr key={customerCategoryId}>
        <td style={textCellStyle}>{categoryName}</td>
        <td style={cellStyle}>
            <ct.NumberBox
                id='maxOverallQuantity'
                labelKey=''
                placeholderKey=''
                min='0'
                value={overrideMaxOverallQuantity}
                callback={onMaxOverallQuantityChange}
                style={({...inlineControlStyle, maxWidth: '100px', minWidth: '50px'})}
                minimal={true}
            />
        </td>
    </tr>
};

export default ReservationCustomerCategoryQuantityOverrideItem;
